module.exports = {
    starTexture: {
        texture: '/img/title/star-texture.png',
        position: {
            x: '37%',
            y: '45%'
        },
        scale: {
            x: '71.5%'
        },
        anchor: {
            x: 0.5,
            y: 0.5
        }
    },

    starMask: {
        texture: '/img/title/star-mask.png',
        position: {
            x: '37%',
            y: '45%'
        },
        scale: {
            x: '71.5%'
        },
        anchor: {
            x: 0.5,
            y: 0.5
        }
    },

    linesTitle: {
        texture: '/img/title/lines.png',
        scale: {
            x: '100%'
        }
    },

    titleBg: {
        texture: '/img/title/title-bg.jpg',
        scale: {
            x: '100%'
        }
    },

    subtitleBox: {
        texture: '/img/title/subtitle-box.png',
        position: {
            x: '50%',
            y: '80%'
        },
        scale: {
            x: '70%'
        },
        anchor: {
            x: 0.5,
            y: 0.5
        }
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/title.js